export const LIN_SCALE = { mm: 0.001, cm: 0.01, m: 1, km: 1000, in: 0.0254, ft: 0.3048, yd: 0.9144, mi: 1609.34 };

export function baseLinearUnit(u = "") {
	u = (typeof u === "string" ? u : "").trim();
	if (u.endsWith("²") || u.endsWith("³")) return u.slice(0, -1);
	if (u.startsWith("sq ")) return u.slice(3);
	if (u === "ha" || u === "ac") return "m";
	return u;
}

export function measurementValue(meas, fmt) {
	if (fmt && typeof fmt === "object" && !fmt.conversionFormula) {
		fmt = fmt.unitCode || "";
	}

	if (typeof fmt === "string") {
		const { length, width, height, value = 0 } = meas;
		if (length != null && width != null && height != null) return length * width * height;
		if (length != null && width != null) return length * width;
		return value;
	}

	const vars = { value: Number(meas.value) || 0 };
	(fmt.requiredMeasurements ?? []).forEach((k) => (vars[k] = Number(meas[k]) || 0));

	if (!measurementValue._cache) measurementValue._cache = {};
	const key = fmt._id ?? fmt.label;
	let fn = measurementValue._cache[key];
	if (!fn) {
		const args = Object.keys(vars);
		fn = new Function(...args, `return ${fmt.conversionFormula || "value"}`);
		measurementValue._cache[key] = fn;
	}
	return fn(...Object.keys(vars).map((k) => vars[k]));
}
